module.exports = __webpack_public_path__ + "static/img/strona_042.e392e2aa.jpg";